import { useEffect, useState } from "react";
import api from "@/lib/api";

const QUALITY_COLOR = {
  highly_auspicious: "#7B906F",
  auspicious: "#E5C158",
  inauspicious: "#C15C3D",
};

export default function NavatharakaPanel({ profileId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    (async () => {
      try { setData(await api.navatharaka(profileId)); }
      catch (err) { console.error("navatharaka failed:", err); }
    })();
  }, [profileId]);
  if (!data) return <div className="text-[#A19E95] font-mono text-sm">Loading Navatharaka Chakra…</div>;

  return (
    <div className="space-y-6" data-testid="navatharaka-panel">
      <div className="border border-[#D4AF37]/40 bg-[#181A1F] p-5">
        <div className="text-[10px] uppercase tracking-widest text-[#D4AF37] font-mono">Janma Nakshatra</div>
        <div className="font-heading text-3xl text-[#E6E1D6] mt-1">{data.janma_nakshatra}</div>
      </div>

      <div>
        <h3 className="font-heading text-xl text-[#D4AF37] mb-3">The 27-Nakshatra Wheel · 3 Cycles × 9 Taras</h3>
        <div className="grid grid-cols-3 md:grid-cols-9 gap-1">
          {data.wheel.map((w) => (
            <div key={w.position}
                 className="border p-2 bg-[#181A1F]"
                 style={{ borderColor: QUALITY_COLOR[w.tara_quality], borderLeftWidth: 3 }}
                 data-testid={`nav-${w.position}`}>
              <div className="text-[9px] font-mono text-[#6E6B64]">
                #{w.position} · C{w.cycle}
              </div>
              <div className="font-heading text-xs text-[#E6E1D6] mt-1 leading-tight">{w.nakshatra}</div>
              <div className="text-[9px] font-mono mt-1 uppercase tracking-widest"
                   style={{ color: QUALITY_COLOR[w.tara_quality] }}>
                {w.tara}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-heading text-xl text-[#D4AF37] mb-3">By Tara Category</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {Object.entries(data.tara_groups).map(([tara, items]) => {
            if (!items.length) return null;
            const col = QUALITY_COLOR[items[0].tara_quality];
            return (
              <div key={tara} className="border p-4 bg-[#181A1F]" style={{ borderLeftColor: col, borderLeftWidth: 3 }}>
                <div className="font-heading text-base" style={{ color: col }}>{tara}</div>
                <div className="text-[10px] font-mono text-[#A19E95] italic mb-2">{items[0].tara_meaning}</div>
                <div className="text-xs text-[#E6E1D6] space-y-0.5">
                  {items.map((i) => <div key={i.position}>{i.nakshatra} <span className="text-[#6E6B64]">(#{i.position})</span></div>)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
